import classNames from 'classnames';
import { NavLink, useLocation } from 'react-router-dom';
import React from 'react';

import { useStore } from '../../store';
import styles from './Stepper.module.scss';

type Props = {
  className?: string;
};

const links = [
  { label: 'Package Details', to: '/package-details' },
  { label: 'Select Quotes', to: '/quotes-comparisons' },
  { label: 'Shipment Details', to: '/shipment-details' },
  { label: 'Additional Info', to: '/additional-info' },
  { label: 'Payment', to: '/payment' },
];

export function Stepper(props: Props) {
  const { className } = props;
  const { pathname } = useLocation();

  const currentStep = useStore((state) => state.currentStep);
  const customOrder = useStore((state) => state.customOrder);
  const progressBarPercentage = useStore((state) => state.progressBarPercentage);
  const lockOfficialQuote = useStore((state) => state.lockOfficialQuote);

  const visibleLinks = links
    .map((link, index) => ({ ...link, index }))
    .filter((link) => !(link.label === 'Payment' && customOrder))
    .filter((link) => !(lockOfficialQuote && link.index < 2));

  return (
    <nav className={classNames(styles.root, className)}>
      <div className={styles.stepperNav}>
        {visibleLinks.map((link, visibleIndex) => {
          const stepIndex = link.index;
          const isCurrentRoute = pathname === link.to;
          const isCompleted = currentStep > stepIndex && !isCurrentRoute;
          let disabled = currentStep < stepIndex;

          if (progressBarPercentage < 100 && currentStep === 1 && stepIndex === 0) {
            disabled = true;
          }

          if (progressBarPercentage >= 100 && currentStep === 1 && stepIndex === 0) {
            disabled = false;
          }

          // Official Quote booking: the price and courier are fixed by the admin,
          // so the recipient must not return to package-details / quotes-comparisons.
          if (lockOfficialQuote && stepIndex < 2) {
            disabled = true;
          }

          return (
            <NavLink
              key={link.to}
              onClick={(e) => {
                if (disabled) {
                  e.preventDefault();
                }
              }}
              aria-disabled={disabled}
              className={classNames(styles.stepperItem, {
                [styles.completed]: isCompleted,
                [styles.disabled]: disabled,
              })}
              activeClassName={styles.active}
              to={link.to}
            >
              <span className={styles.stepperIcon}>
                <span className={styles.stepperNumber}>{visibleIndex + 1}</span>
                <span className={styles.stepperCheck}>&#10003;</span>
              </span>
              <span className={styles.stepperLabel}>
                <span className={styles.stepperTitle}>{link.label}</span>
              </span>
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}
